import React from "react"
import { LinkOverlay, LinkBox, Box, Heading } from "@chakra-ui/react"
import Card from "../../common/components/Card"
import { getPopMediaThumb } from "../../utilities/imageUtils"
import { mapAccessToken } from "../../config/map"
import SocialImage from "../../common/components/SocialImage"
import { VideoThumbnail } from "../../media/components/VideoThumbnail"
import NextLink from "next/link"

const imageHeight = "220px"

const GuideCard = (props) => {
  const { guide } = props
  const imageObj = getPopMediaThumb(guide) || {
    url:
      "https://api.mapbox.com/styles/v1/mapbox/satellite-v8/static/" +
      guide.location.coordinates[0] +
      "," +
      guide.location.coordinates[1] +
      ",16.5,0.00/500x300@2x?access_token=" +
      mapAccessToken,
  }
  return (
    <LinkBox as="article">
      <Card variant="link" overflow="hidden">
        <Box
          m={-5}
          mb={3}
          height={imageHeight}
          position="relative"
          overflow="hidden"
        >
          {imageObj?.video ? (
            <VideoThumbnail videoUrl={imageObj?.video} />
          ) : (
            <SocialImage imageObj={imageObj} height="100%" width="100%" />
          )}
        </Box>
        <NextLink passHref href={`/guides/${guide.slug}`}>
          <LinkOverlay>
            <Heading variant="link" as="h3" size="md" mb={0}>
              {guide.name}
            </Heading>
          </LinkOverlay>
        </NextLink>
      </Card>
    </LinkBox>
  )
}

export default GuideCard
